import { Badge } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

const Bold = styled.span`
  font-weight: 700;
`;

const VerticalListHeader = styled.div`
  ${Badge.S.BadgeWrapper} {
    padding: 0;
  }

  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const TopContent = styled.div`
  align-items: center;
  display: flex;
  gap: 16px;
  justify-content: space-between;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 16px;

  .tooltip-container {
    text-wrap: auto;
  }
`;

export { Bold, ButtonGroup, TopContent, VerticalListHeader };
